import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import './modal.css'
import BooksModal from '../modals/Books'
import {
  newEventProject,
  updateEventProject,
  newEventDuration,
  updateEventDuration,
  newEventValue,
  updateEventValue,
  newReadingEvent,
  updateReadingEvent,
  addToEvent,
  deleteEvent
} from '@/graphql/mutations/event'
import { updateBookPref } from '@/graphql/mutations/bookPref'
import { booksQuery } from '@/graphql/queries/book'
import { updateCurrentTask } from '@/graphql/mutations/task'
import { updateCurrentTracker } from '@/graphql/mutations/tracker'
import { trackerTasksQuery } from '@/graphql/queries/tracker'
import { GC_USER_ID, PROJECT_TRACKER_ID } from '@/constants'
import DeleteModal from '../modals/Delete'
import TimerModal from '../modals/Timer'

import * as moment from 'moment'
import momenttz from 'moment-timezone'
import { Modal, Paper, Button, CircularProgress, Checkbox } from 'material-ui'
import List, { ListItem, ListItemText, ListItemIcon } from 'material-ui/List'
import TextField from 'material-ui/TextField'
import Select from 'material-ui/Select'
import { MenuItem } from 'material-ui/Menu'
import { InputLabel } from 'material-ui/Input'
import { FormControl, FormGroup, FormControlLabel } from 'material-ui/Form'
import IconButton from 'material-ui/IconButton'
import ClearIcon from 'material-ui-icons/Clear'
import TimelapseIcon from 'material-ui-icons/Timelapse'
import AlarmOnIcon from 'material-ui-icons/AlarmOn'
import AssignmentIcon from 'material-ui-icons/Assignment'
import CommentIcon from 'material-ui-icons/Comment'
import DateRangeIcon from 'material-ui-icons/DateRange'
import SentimentSatisfiedIcon from 'material-ui-icons/SentimentSatisfied'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import BookmarkBorderIcon from 'material-ui-icons/BookmarkBorder'
import BookmarkIcon from 'material-ui-icons/Bookmark'
import DescriptionIcon from 'material-ui-icons/Description'
import BookIcon from 'material-ui-icons/Book'
import TaskEditModal from './TaskEdit'
import CheckIcon from 'material-ui-icons/Check'
import Loading from './Loading'

@graphql(trackerTasksQuery, {
  name: 'trackerTasksQuery',
  options: () => ({
    variables: {
      id: global.localStorage.getItem(PROJECT_TRACKER_ID) || ''
    },
    fetchPolicy: 'cache-and-network'
  })
})
@graphql(updateCurrentTask, {
  name: 'updateCurrentTask',
  options: {
    refetchQueries: () => [
      {
        query: trackerTasksQuery,
        variables: {
          id: global.localStorage.getItem(PROJECT_TRACKER_ID) || ''
        }
      }
    ]
  }
})
@graphql(updateCurrentTracker, {
  name: 'updateCurrentTracker',
  options: {
    refetchQueries: () => [
      {
        query: trackerTasksQuery,
        variables: {
          id: global.localStorage.getItem(PROJECT_TRACKER_ID) || ''
        }
      }
    ]
  }
})
@graphql(updateBookPref, {
  name: 'updateBookPref',
  options: {
    refetchQueries: () => [
      {
        query: booksQuery,
        variables: {
          userId: global.localStorage.getItem(GC_USER_ID)
        }
      }
    ]
  }
})
@graphql(newEventProject, {
  name: 'newEventProject',
  options: {
    refetchQueries: ['eventsQuery', 'eventsQueryAgg']
  }
})
@graphql(updateEventProject, {
  name: 'updateEventProject',
  options: {
    refetchQueries: ['eventsQuery', 'eventsQueryAgg']
  }
})
@graphql(newEventDuration, {
  name: 'newEventDuration',
  options: {
    refetchQueries: ['eventsQuery', 'eventsQueryAgg']
  }
})
@graphql(updateEventDuration, {
  name: 'updateEventDuration',
  options: {
    refetchQueries: ['eventsQuery', 'eventsQueryAgg']
  }
})
@graphql(newReadingEvent, {
  name: 'newReadingEvent',
  options: {
    refetchQueries: ['eventsQuery', 'eventsQueryAgg']
  }
})
@graphql(updateReadingEvent, {
  name: 'updateReadingEvent',
  options: {
    refetchQueries: ['eventsQuery', 'eventsQueryAgg']
  }
})
@graphql(newEventValue, {
  name: 'newEventValue',
  options: {
    refetchQueries: ['eventsQuery', 'eventsQueryAgg']
  }
})
@graphql(updateEventValue, {
  name: 'updateEventValue',
  options: {
    refetchQueries: ['eventsQuery', 'eventsQueryAgg']
  }
})
@graphql(addToEvent, {
  name: 'addToEvent',
  options: {
    refetchQueries: ['eventsQuery', 'eventsQueryAgg']
  }
})
@graphql(deleteEvent, {
  name: 'deleteEvent',
  options: {
    refetchQueries: ['eventsQuery', 'eventsQueryAgg']
  }
})
export default class EventEditModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      OpenDelete: false,
      OpenBooks: false,
      OpenTask: false,
      OpenTimer: false,
      event: '',
      savingEvent: false,
      tasks: '',
      task: '',
      taskType: '',

      maxPage: '',
      percentRead: '',

      isUpdatedBookPref: false,
      savingBookPref: false,
      isUpdatedTask: false,
      savingTask: false,
      isUpdatedSubtask: false,
      savingSubtask: false,
      isNew: false,
      loadingDel: false
    }
  }

  // reset state if the seeded prop is updated
  componentWillReceiveProps(nextProps) {
    if (nextProps.event !== this.props.event) {
      this.setState({ event: nextProps.event })
    }

    if (nextProps.open !== this.props.open) {
      this.setState({ open: nextProps.open })
    }
    if (nextProps.openTimer !== this.props.openTimer) {
      this.setState({ OpenTimer: nextProps.openTimer })
    }

    if (nextProps.trackerTasksQuery !== this.props.trackerTasksQuery) {
      if (nextProps.trackerTasksQuery.Tracker) {
        var info = nextProps.trackerTasksQuery.Tracker
        this.setState({ tasks: info.tasks })
        if (
          this.props.action === 'add' &&
          info.currentId &&
          !this.state.isNew
        ) {
          var newEvent = ''
          if (nextProps.event !== this.props.event) {
            newEvent = Object.assign({}, nextProps.event)
          } else {
            newEvent = Object.assign({}, this.state.event)
          }

          newEvent.task = {
            id: info.currentId,
            name: info.currentName
          }
          var currTask = info.tasks.filter(e => e.id === info.currentId)
          if (currTask.length === 1 && currTask[0].currentId) {
            newEvent.subtask = {
              id: currTask[0].currentId,
              name: currTask[0].currentName
            }
          }
          this.setState({ event: newEvent })
        }
      }
    }
  }

  handleOpenBooks = () => {
    this.setState({ OpenBooks: true })
  }

  handleCloseBooks = () => {
    this.setState({
      OpenBooks: false
    })
  }

  handleCloseTimer = () => {
    this.props.onCloseTimer()
    this.setState({
      OpenTimer: false
    })
  }

  updateCurrentBook = (bookId, bookName, bookPrefId, maxPage, totalPages) => {
    var newEvent = Object.assign({}, this.state.event)
    newEvent.book = {
      id: bookId,
      name: bookName,
      totalPages: totalPages
    }
    newEvent.bookPref = {
      id: bookPrefId
    }
    newEvent.options = {
      value: this.state.event.options.value,
      pageStart: maxPage,
      pageEnd: this.state.event.options.value
    }
    this.setState({ event: newEvent })
  }

  handleClose = () => {
    this.props.onClose()
    this.setState({
      open: false
    })
  }

  handleOpenDelete = () => {
    this.setState({
      OpenDelete: true
    })
  }

  handleCloseTask = () => {
    this.setState({
      OpenTask: false
    })
  }

  handleCloseDelete = () => {
    this.setState({
      OpenDelete: false
    })
  }

  handleDelete = id => {
    this.setState({ loadingDel: true })
    this.props
      .deleteEvent({
        variables: {
          id: id
        }
      })
      .then(() => {
        this.props.onClose()
        this.setState({
          loadingDel: false,
          OpenDelete: false,
          open: false
        })
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.props.onClose()
        this.setState({
          loadingDel: false,
          OpenDelete: false,
          open: false
        })
      })
  }

  handleSuccess = (id, eType) => {
    if (eType.includes('happenedFrom:')) {
      this.props
        .addToEvent({
          variables: {
            events1EventId: this.props.from,
            events2EventId: id
          }
        })
        .then(() => {
          this.props.onClose()
          this.setState({
            savingEvent: false,
            open: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            savingEvent: false,
            open: false
          })
        })
    } else {
      this.props.onClose()
      this.setState({
        savingEvent: false,
        open: false
      })
    }
  }

  handleSaveEvent = (type, eType) => {
    if (this.state.isUpdatedTask) {
      this.setState({ savingTask: true })
      //update current to task

      this.props
        .updateCurrentTracker({
          variables: {
            currentId: this.state.event.task.id,
            currentName: this.state.event.task.name,
            id: this.state.event.tracker.id,
            userId: global.localStorage.getItem(GC_USER_ID)
          }
        })
        .then(() => {
          this.setState({
            isUpdatedTask: false,
            savingTask: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.setState({
            isUpdatedTask: false,
            savingTask: false
          })
        })
    }
    if (this.state.isUpdatedSubtask) {
      this.setState({ savingSubtask: true })
      this.props
        .updateCurrentTask({
          variables: {
            currentId: this.state.event.subtask.id,
            currentName: this.state.event.subtask.name,
            id: this.state.event.task.id,
            userId: global.localStorage.getItem(GC_USER_ID)
          }
        })
        .then(() => {
          this.setState({
            isUpdatedSubtask: false,
            savingSubtask: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.setState({
            isUpdatedSubtask: false,
            savingSubtask: false
          })
        })
    }
    if (this.state.isUpdatedBookPref) {
      this.setState({ savingBookPref: true })
      this.props
        .updateBookPref({
          variables: {
            maxPage: this.state.maxPage,
            percentRead: this.state.percentRead,
            id: this.state.event.bookPref.id,
            userId: global.localStorage.getItem(GC_USER_ID)
          }
        })
        .then(() => {
          this.setState({
            isUpdatedBookPref: false,
            savingBookPref: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.setState({
            isUpdatedBookPref: false,
            savingBookPref: false
          })
        })
    }
    this.setState({ savingEvent: true })
    if (this.props.action === 'add') {
      switch (type) {
        case 'bodyweight':
        case 'checked':
        case 'energy':
          this.props
            .newEventValue({
              variables: {
                startedAt: this.state.event.startedAt,
                completedAt: this.state.event.startedAt,
                dataOrigin: this.props.origin,
                eventType: eType,
                options: this.state.event.options,
                mood: this.state.event.mood,
                comment: this.state.event.comment,
                trackerId: this.state.event.tracker.id,
                userId: global.localStorage.getItem(GC_USER_ID)
              }
            })
            .then(data => {
              this.handleSuccess(data.data.createEvent.id, eType)
            })
            .catch(error => {
              console.log(error.message + ' Please refresh.')
              this.props.onClose()
              this.setState({
                savingEvent: false,
                open: false
              })
            })
          break
        case 'reading':
          this.props
            .newReadingEvent({
              variables: {
                startedAt: this.state.event.startedAt,
                completedAt: this.state.event.completedAt,
                minutes: this.state.event.minutes,
                dataOrigin: this.props.origin,
                eventType: eType,
                bookId: this.state.event.book.id,
                bookPrefId: this.state.event.bookPref.id,
                options: this.state.event.options,
                mood: this.state.event.mood,
                comment: this.state.event.comment,
                trackerId: this.state.event.tracker.id,
                userId: global.localStorage.getItem(GC_USER_ID)
              }
            })
            .then(data => {
              this.handleSuccess(data.data.createEvent.id, eType)
            })
            .catch(error => {
              console.log(error.message + ' Please refresh.')
              this.props.onClose()
              this.setState({
                savingEvent: false,
                open: false
              })
            })
          break
        case 'project':
          this.props
            .newEventProject({
              variables: {
                startedAt: this.state.event.startedAt,
                completedAt: this.state.event.completedAt,
                minutes: this.state.event.minutes,
                dataOrigin: this.props.origin,
                eventType: eType,
                mood: this.state.event.mood,
                comment: this.state.event.comment,
                trackerId: this.state.event.tracker.id,
                taskId: this.state.event.task.id,
                subtaskId: this.state.event.subtask.id,
                userId: global.localStorage.getItem(GC_USER_ID)
              }
            })
            .then(data => {
              this.handleSuccess(data.data.createEvent.id, eType)
            })
            .catch(error => {
              console.log(error.message + ' Please refresh.')
              this.props.onClose()
              this.setState({
                savingEvent: false,
                open: false
              })
            })
          break
        default:
          this.props
            .newEventDuration({
              variables: {
                startedAt: this.state.event.startedAt,
                completedAt: this.state.event.completedAt,
                minutes: this.state.event.minutes,
                dataOrigin: this.props.origin,
                eventType: eType,
                options: this.state.event.options,
                mood: this.state.event.mood,
                comment: this.state.event.comment,
                trackerId: this.state.event.tracker.id,
                userId: global.localStorage.getItem(GC_USER_ID)
              }
            })
            .then(data => {
              this.handleSuccess(data.data.createEvent.id, eType)
            })
            .catch(error => {
              console.log(error.message + ' Please refresh.')
              this.props.onClose()
              this.setState({
                savingEvent: false,
                open: false
              })
            })
          break
      }
    } else if (this.props.action === 'edit') {
      switch (type) {
        case 'bodyweight':
        case 'checked':
        case 'energy':
          this.props
            .updateEventValue({
              variables: {
                startedAt: this.state.event.startedAt,
                completedAt: this.state.event.startedAt,
                eventType: eType,
                options: this.state.event.options,
                mood: this.state.event.mood,
                comment: this.state.event.comment,
                trackerId: this.state.event.tracker.id,
                userId: global.localStorage.getItem(GC_USER_ID),
                id: this.state.event.id
              }
            })
            .then(() => {
              this.props.onClose()
              this.setState({
                savingEvent: false,
                open: false
              })
            })
            .catch(error => {
              console.log(error.message + ' Please refresh.')
              this.props.onClose()
              this.setState({
                savingEvent: false,
                open: false
              })
            })
          break
        case 'reading':
          this.props
            .updateReadingEvent({
              variables: {
                startedAt: this.state.event.startedAt,
                completedAt: this.state.event.completedAt,
                minutes: this.state.event.minutes,
                eventType: eType,
                bookId: this.state.event.book.id,
                bookPrefId: this.state.event.bookPref.id,
                options: this.state.event.options,
                mood: this.state.event.mood,
                comment: this.state.event.comment,
                trackerId: this.state.event.tracker.id,
                userId: global.localStorage.getItem(GC_USER_ID),
                id: this.state.event.id
              }
            })
            .then(() => {
              this.props.onClose()
              this.setState({
                savingEvent: false,
                open: false
              })
            })
            .catch(error => {
              console.log(error.message + ' Please refresh.')
              this.props.onClose()
              this.setState({
                savingEvent: false,
                open: false
              })
            })
          break
        case 'project':
          this.props
            .updateEventProject({
              variables: {
                startedAt: this.state.event.startedAt,
                completedAt: this.state.event.completedAt,
                minutes: this.state.event.minutes,
                eventType: eType,
                mood: this.state.event.mood,
                comment: this.state.event.comment,
                trackerId: this.state.event.tracker.id,
                taskId: this.state.event.task.id,
                subtaskId: this.state.event.subtask.id,
                userId: global.localStorage.getItem(GC_USER_ID),
                id: this.state.event.id
              }
            })
            .then(() => {
              this.props.onClose()
              this.setState({
                savingEvent: false,
                open: false
              })
            })
            .catch(error => {
              console.log(error.message + ' Please refresh.')
              this.props.onClose()
              this.setState({
                savingEvent: false,
                open: false
              })
            })
          break
        default:
          this.props
            .updateEventDuration({
              variables: {
                startedAt: this.state.event.startedAt,
                completedAt: this.state.event.completedAt,
                minutes: this.state.event.minutes,
                eventType: eType,
                options: this.state.event.options,
                mood: this.state.event.mood,
                comment: this.state.event.comment,
                trackerId: this.state.event.tracker.id,
                userId: global.localStorage.getItem(GC_USER_ID),
                id: this.state.event.id
              }
            })
            .then(() => {
              this.props.onClose()
              this.setState({
                savingEvent: false,
                open: false
              })
            })
            .catch(error => {
              console.log(error.message + ' Please refresh.')
              this.props.onClose()
              this.setState({
                savingEvent: false,
                open: false
              })
            })
          break
      }
    }
    global.localStorage.setItem(PROJECT_TRACKER_ID, '')
    this.setState({
      isNew: false
    })
  }

  handleTaskAdd = type => {
    this.setState({ taskType: type })
    if (type === 'task') {
      var newTask = {
        name: '',
        isCompleted: false,
        minutesTotal: 0,
        minutesSpent: 0,
        progressPercentage: 0,
        tracker: {
          id: this.state.event.tracker.id
        }
      }
      this.setState({ task: newTask })
    } else if (type === 'subtask') {
      var newSubtask = {
        name: '',
        isCompleted: false,
        minutesTotal: 0,
        minutesSpent: 0,
        progressPercentage: 0,
        task: {
          id: this.state.event.task.id
        }
      }
      this.setState({ task: newSubtask })
    }
    this.setState({ OpenTask: true })
  }

  handleChange = name => event => {
    var newEvent = Object.assign({}, this.state.event)
    switch (name) {
      case 'optionsEventValue':
        if (newEvent.tracker.type === 'energy') {
          newEvent.options = { value: parseInt(event.target.value, 10) }
        } else {
          newEvent.options = { value: event.target.value }
        }
        break
      case 'optionsSleepQualityValue':
        newEvent.options = {
          value: parseInt(event.target.value, 10),
          isNap: this.state.event.options.isNap,
          brianClearness: this.state.event.options.brianClearness
        }
        break
      case 'optionsBrainClearness':
        newEvent.options = {
          value: this.state.event.options.value,
          isNap: this.state.event.options.isNap,
          brianClearness: event.target.value
        }
        break
      case 'OptionsIsNap':
        newEvent.options = {
          value: this.state.event.options.value,
          isNap: !this.state.event.options.isNap,
          brianClearness: this.state.event.options.brianClearness
        }
        break
      case 'optionsPagesValue':
        newEvent.options = {
          value: parseInt(event.target.value, 10),
          pageStart: this.state.event.options.pageStart,
          pageEnd: this.state.event.options.pageEnd
        }
        break
      case 'optionsPageStart':
        var pV = this.state.event.options.value
        var pS = parseInt(event.target.value, 10)
        var pE = this.state.event.options.pageEnd
        if (pS <= pE && pS > 0 && pE > 0) {
          pV = pE - pS
        }
        newEvent.options = {
          value: pV,
          pageStart: pS,
          pageEnd: pE
        }
        break
      case 'optionsPageEnd':
        pV = this.state.event.options.value
        pS = this.state.event.options.pageStart
        pE = parseInt(event.target.value, 10)
        if (pS <= pE && pS > 0 && pE > 0) {
          pV = pE - pS
        }
        newEvent.options = {
          value: pV,
          pageStart: pS,
          pageEnd: pE
        }
        if (
          this.state.event.book &&
          this.state.event.book.totalPages > 0 &&
          pE > 0
        ) {
          var percent = parseInt(
            pE * 100 / this.state.event.book.totalPages,
            10
          )
          if (percent > 100) {
            percent = 100
          }
          this.setState({ percentRead: percent })
        }
        this.setState({
          maxPage: pE,
          isUpdatedBookPref: true
        })
        break
      case 'completedAt':
      case 'startedAt':
        newEvent[name] = momenttz
          .tz(event.target.value, 'America/Los_Angeles')
          .format()
        var s = moment(new Date(newEvent.startedAt))
        var e = moment(new Date(newEvent.completedAt))
        if (s.isSameOrBefore(e)) {
          newEvent.minutes = e.diff(s, 'minutes')
        } else {
          newEvent.minutes = 0
        }
        break
      case 'taskId':
        this.setState({ isUpdatedTask: true })
        if (event.target.value === 'addTask') {
          this.handleTaskAdd('task')
        } else {
          var t = JSON.parse(event.target.value)
          newEvent.task = { id: t.id, name: t.name }
        }
        break
      case 'subtaskId':
        this.setState({
          isUpdatedSubtask: true
        })
        if (event.target.value === 'addSubtask') {
          this.handleTaskAdd('subtask')
        } else {
          var st = JSON.parse(event.target.value)
          newEvent.subtask = { id: st.id, name: st.name }
        }
        break
      case 'bookId':
        newEvent.book = { id: event.target.value }
        break
      case 'bookPrefId':
        newEvent.bookPref = { id: event.target.value }
        break
      case 'minutes':
        newEvent[name] = parseInt(event.target.value, 10)
        if (this.state.event.eventType === 'plan') {
          newEvent.completedAt = moment(new Date(newEvent.startedAt))
            .add(parseInt(event.target.value, 10), 'minutes')
            .format()
        }
        break
      case 'mood':
        newEvent[name] = parseInt(event.target.value, 10)
        break
      default:
        newEvent[name] = event.target.value
        break
    }
    this.setState({ event: newEvent })
  }

  updateTaskAfterAdd = (id, name) => {
    this.setState({ isNew: true })
    var newEvent = Object.assign({}, this.state.event)
    if (this.state.taskType === 'task') {
      this.setState({ isUpdatedTask: true })
      newEvent.task = {
        id: id,
        name: name
      }
    } else if (this.state.taskType === 'subtask') {
      this.setState({
        isUpdatedSubtask: true
      })
      newEvent.subtask = {
        id: id,
        name: name
      }
    }
    this.setState({ event: newEvent })
  }

  eventFromTimer = e => {
    this.setState({ open: true, event: e })
  }

  render() {
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
          className="modalAddToday"
          disableAutoFocus
        >
          <Paper className="paperAddTodayMoreInfo" style={{ borderRadius: 16 }}>
            <div id="clearBtnBedTime" className="divAddTpday">
              <div className="divClearButton">
                <IconButton
                  className="btn btn-default btn-style"
                  onClick={this.handleClose}
                >
                  <ClearIcon className="iconClear" />
                </IconButton>
              </div>
              {this.props.trackerTasksQuery.loading ? (
                <CircularProgress
                  style={{
                    margin: 5,
                    color: 'lightgrey'
                  }}
                  size={40}
                />
              ) : (
                <List>
                  {this.state.event.tracker && (
                    <ListItem className="listItemSleepTimeComplete">
                      {this.state.event.tracker.type !== 'checked' && (
                        <ListItemIcon>
                          <TimelapseIcon className="editIcons" />
                        </ListItemIcon>
                      )}
                      {this.state.event.tracker.type === 'energy' ||
                      this.state.event.tracker.type === 'bodyweight' ? (
                        <TextField
                          id="minutes"
                          label={
                            this.state.event.tracker.type === 'energy'
                              ? 'Energy level (1-10)'
                              : 'Body Weight (LB)'
                          }
                          className="textField"
                          value={this.state.event.options.value || ''}
                          onChange={this.handleChange('optionsEventValue')}
                          margin="normal"
                        />
                      ) : (
                        this.state.event.tracker.type !== 'checked' && (
                          <TextField
                            id="minutes"
                            label={'Minutes spent'}
                            className="textField"
                            value={this.state.event.minutes || ''}
                            onChange={this.handleChange('minutes')}
                            margin="normal"
                          />
                        )
                      )}
                    </ListItem>
                  )}
                  <ListItem className="modalContentSmallTime">
                    <ListItemIcon>
                      <DateRangeIcon className="editIconsSmall" />
                    </ListItemIcon>
                    <TextField
                      id="startedAt"
                      label={
                        this.state.event.tracker &&
                        !this.state.event.tracker.isDuration
                          ? 'Time'
                          : 'Start'
                      }
                      type="datetime-local"
                      defaultValue={moment(
                        new Date(this.state.event.startedAt)
                      ).format('YYYY-MM-DDTHH:mm')}
                      onChange={this.handleChange('startedAt')}
                      className="textFieldLong"
                      InputLabelProps={{
                        className: 'textFieldTimeTiny'
                      }}
                      inputProps={{
                        className: 'textFieldTimeSmall'
                      }}
                    />
                  </ListItem>
                  {this.state.event.tracker &&
                    this.state.event.tracker.isDuration && (
                      <ListItem className="modalContentSmallTime">
                        <ListItemIcon>
                          <AlarmOnIcon className="editIconsSmall" />
                        </ListItemIcon>
                        <TextField
                          id="completedAt"
                          label="End"
                          type="datetime-local"
                          value={moment(
                            new Date(this.state.event.completedAt)
                          ).format('YYYY-MM-DDTHH:mm')}
                          onChange={this.handleChange('completedAt')}
                          className="textFieldLong"
                          InputLabelProps={{
                            className: 'textFieldTimeTiny'
                          }}
                          inputProps={{
                            className: 'textFieldTimeSmall',
                            step: 300 // 5 min
                          }}
                        />
                      </ListItem>
                    )}
                  {this.props.action === 'edit' &&
                    this.state.event.tracker &&
                    this.state.event.tracker.type !== 'energy' && (
                      <ListItem className="modalContentSmallTime">
                        <ListItemIcon>
                          <AssignmentIcon className="iconSleepAtTimeDate" />
                        </ListItemIcon>
                        <TextField
                          id="trackerName"
                          label="Tracker Name"
                          className="textFieldLong"
                          value={this.state.event.tracker.name}
                          onChange={this.handleChange('trackerName')}
                          margin="normal"
                          InputLabelProps={{
                            className: 'textFieldTimeTiny'
                          }}
                          inputProps={{
                            className: 'textFieldTimeSmall'
                          }}
                        />
                      </ListItem>
                    )}

                  {this.state.event.tracker &&
                    this.state.event.tracker.type === 'project' && (
                      <ListItem className="modalContentSmallTime">
                        <ListItemIcon>
                          <AssignmentIcon className="iconSleepAtTimeDate" />
                        </ListItemIcon>
                        <FormControl className="textField">
                          <InputLabel htmlFor="task">Task</InputLabel>
                          <Select
                            value={
                              JSON.stringify({
                                id: this.state.event.task.id,
                                name: this.state.event.task.name
                              }) || ''
                            }
                            onChange={this.handleChange('taskId')}
                            inputProps={{
                              name: 'task',
                              id: 'task'
                            }}
                          >
                            {this.state.tasks &&
                              this.state.tasks.map((e, index) => (
                                <MenuItem
                                  key={index}
                                  value={JSON.stringify({
                                    id: e.id,
                                    name: e.name
                                  })}
                                >
                                  {e.name}
                                </MenuItem>
                              ))}
                            <MenuItem value={'addTask'}>Add Task</MenuItem>
                          </Select>
                        </FormControl>
                        <ListItemIcon>
                          <AssignmentIcon className="iconSleepAtTimeDate" />
                        </ListItemIcon>
                        <FormControl className="textField">
                          <InputLabel htmlFor="subtask">Sub Task</InputLabel>
                          <Select
                            value={
                              JSON.stringify({
                                id: this.state.event.subtask.id,
                                name: this.state.event.subtask.name
                              }) || ''
                            }
                            onChange={this.handleChange('subtaskId')}
                            inputProps={{
                              name: 'subtask',
                              id: 'subtask'
                            }}
                          >
                            {this.state.tasks &&
                              this.state.tasks.filter(
                                e => e.id === this.state.event.task.id
                              ).length > 0 &&
                              this.state.tasks
                                .filter(
                                  e => e.id === this.state.event.task.id
                                )[0]
                                .subtask.map((e, index) => (
                                  <MenuItem
                                    key={index}
                                    value={JSON.stringify({
                                      id: e.id,
                                      name: e.name
                                    })}
                                  >
                                    {e.name}
                                  </MenuItem>
                                ))}
                            <MenuItem value={'addSubtask'}>
                              Add Subtask
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </ListItem>
                    )}
                  {this.state.event.book && (
                    <ListItem className="modalContentNewSection">
                      <ListItemIcon>
                        <BookIcon className="iconSleepAtTimeDate" />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          this.state.event.book.name === ''
                            ? 'Book Name'
                            : this.state.event.book.name
                        }
                      />
                      <div style={{ textAlign: 'left', marginTop: 10 }}>
                        <Button
                          onClick={() => this.handleOpenBooks()}
                          className="iconAllProjects"
                          size="small"
                        >
                          <ChevronRightIcon className="iconBtnCurrentBookRefresh" />{' '}
                          <span style={{ color: 'grey', fontSize: 16 }}>
                            {this.state.event.book.name === ''
                              ? 'Add a book'
                              : 'All Books'}
                          </span>
                        </Button>
                      </div>
                    </ListItem>
                  )}
                  {this.state.event.book && (
                    <ListItem className="modalContentSmallTime">
                      <ListItemIcon>
                        <DescriptionIcon className="editIconsSmall" />
                      </ListItemIcon>
                      <TextField
                        id="pages"
                        label="Pages"
                        className="textFieldSmall"
                        value={this.state.event.options.value || ''}
                        onChange={this.handleChange('optionsPagesValue')}
                        margin="normal"
                        InputLabelProps={{
                          className: 'textFieldTimeTiny'
                        }}
                        inputProps={{
                          className: 'textFieldTimeSmall'
                        }}
                      />
                      <ListItemIcon>
                        <BookmarkBorderIcon className="editIconsSmall" />
                      </ListItemIcon>
                      <TextField
                        id="pageStart"
                        label="Start Page"
                        className="textFieldSmall"
                        value={this.state.event.options.pageStart || ''}
                        onChange={this.handleChange('optionsPageStart')}
                        margin="normal"
                        InputLabelProps={{
                          className: 'textFieldTimeTiny'
                        }}
                        inputProps={{
                          className: 'textFieldTimeSmall'
                        }}
                      />
                      <ListItemIcon>
                        <BookmarkIcon className="editIconsSmall" />
                      </ListItemIcon>
                      <TextField
                        id="pageEnd"
                        label="End Page"
                        className="textFieldSmall"
                        value={this.state.event.options.pageEnd || ''}
                        onChange={this.handleChange('optionsPageEnd')}
                        margin="normal"
                        InputLabelProps={{
                          className: 'textFieldTimeTiny'
                        }}
                        inputProps={{
                          className: 'textFieldTimeSmall'
                        }}
                      />
                    </ListItem>
                  )}
                  {this.state.event.tracker &&
                    this.state.event.tracker.type === 'sleep' && (
                      <ListItem className="listItemSleepTimeComplete">
                        <ListItemIcon>
                          <DescriptionIcon className="editIconsSmall" />
                        </ListItemIcon>
                        <TextField
                          id="sleepQulity"
                          label="Sleep Quality"
                          className="textField"
                          value={this.state.event.options.value || ''}
                          onChange={this.handleChange(
                            'optionsSleepQualityValue'
                          )}
                          InputLabelProps={{
                            className: 'textFieldTimeTiny'
                          }}
                          inputProps={{
                            className: 'textFieldTimeSmall'
                          }}
                        />
                        <FormControl className="textField">
                          <InputLabel htmlFor="brainClearness">
                            Brain Clearness
                          </InputLabel>
                          <Select
                            value={this.state.event.options.brianClearness}
                            onChange={this.handleChange(
                              'optionsBrainClearness'
                            )}
                            inputProps={{
                              name: 'brainClearness',
                              id: 'brainClearness'
                            }}
                          >
                            <MenuItem value="" />
                            <MenuItem value={'Very Clear'}>Very Clear</MenuItem>
                            <MenuItem value={'Clear'}>Clear</MenuItem>
                            <MenuItem value={'Normal'}>Normal</MenuItem>
                            <MenuItem value={'Unclear'}>Unclear</MenuItem>
                            <MenuItem value={'Very Unclear'}>
                              Very Unclear
                            </MenuItem>
                          </Select>
                        </FormControl>
                        <FormGroup row style={{ paddingLeft: 30 }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.event.options.isNap}
                                onChange={this.handleChange('OptionsIsNap')}
                                value="isNap"
                                style={{ color: 'lightblue' }}
                              />
                            }
                            label="Nap"
                          />
                        </FormGroup>
                      </ListItem>
                    )}

                  <ListItem className="listItemSleepTimeComplete">
                    <ListItemIcon>
                      <SentimentSatisfiedIcon className="iconSleepScore" />
                    </ListItemIcon>
                    <FormControl className="textField">
                      <InputLabel htmlFor="mood">Mood</InputLabel>
                      <Select
                        value={
                          this.state.event.mood ? this.state.event.mood : ''
                        }
                        onChange={this.handleChange('mood')}
                        inputProps={{
                          name: 'mood',
                          id: 'mood'
                        }}
                      >
                        <MenuItem value="" />
                        <MenuItem value={10}>
                          <span role="img" aria-label="emoji">
                            🤣
                          </span>
                        </MenuItem>
                        <MenuItem value={9}>
                          <span role="img" aria-label="emoji">
                            😆
                          </span>
                        </MenuItem>
                        <MenuItem value={8}>
                          <span role="img" aria-label="emoji">
                            😁
                          </span>
                        </MenuItem>
                        <MenuItem value={7}>
                          <span role="img" aria-label="emoji">
                            😀
                          </span>
                        </MenuItem>
                        <MenuItem value={6}>
                          <span role="img" aria-label="emoji">
                            🙂
                          </span>
                        </MenuItem>
                        <MenuItem value={5}>
                          <span role="img" aria-label="emoji">
                            😞
                          </span>
                        </MenuItem>
                        <MenuItem value={4}>
                          <span role="img" aria-label="emoji">
                            ☹️
                          </span>
                        </MenuItem>
                        <MenuItem value={3}>
                          <span role="img" aria-label="emoji">
                            😢
                          </span>
                        </MenuItem>
                        <MenuItem value={2}>
                          <span role="img" aria-label="emoji">
                            😡
                          </span>
                        </MenuItem>
                        <MenuItem value={1}>
                          <span role="img" aria-label="emoji">
                            😫
                          </span>
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </ListItem>
                  <ListItem className="listItemSleepTimeComplete">
                    <ListItemIcon>
                      <CommentIcon className="iconSleepScore" />
                    </ListItemIcon>
                    <TextField
                      id="comment"
                      label="Commment"
                      multiline
                      defaultValue={this.state.event.comment}
                      onChange={this.handleChange('comment')}
                      margin="normal"
                      variant="outlined"
                      className="textField"
                      InputLabelProps={{
                        className: 'textFieldTimeTiny'
                      }}
                    />
                  </ListItem>

                  <ListItem className="modalContentDone">
                    {this.state.event.eventType &&
                      this.state.event.tracker &&
                      this.state.event.tracker.type !== 'energy' &&
                      !this.state.event.eventType.includes(
                        'happenedRoutine:'
                      ) &&
                      !this.state.event.eventType.includes('happenedFrom:') && (
                        <Button
                          onClick={() =>
                            this.handleSaveEvent(
                              this.state.event.tracker.type,
                              'plan'
                            )
                          }
                          className="iconBtnCheck"
                          size="small"
                        >
                          {this.state.event.eventType === 'plan' ? (
                            this.state.savingEvent ? (
                              <Loading />
                            ) : this.state.savingBookPref ? (
                              <Loading />
                            ) : this.state.savingTask ? (
                              <Loading />
                            ) : this.state.savingSubtask ? (
                              <Loading />
                            ) : (
                              <ChevronLeftIcon
                                style={{
                                  color: 'lightgrey',
                                  fontSize: 20,
                                  paddingLeft: 10
                                }}
                              />
                            )
                          ) : (
                            ''
                          )}
                          <span style={{ color: 'grey', fontSize: 15 }}>
                            Plan
                          </span>
                        </Button>
                      )}
                    {this.props.action === 'edit' && (
                      <Button
                        onClick={this.handleOpenDelete}
                        className="iconBtnCheck"
                        size="small"
                      >
                        {' '}
                        <span style={{ color: 'grey', fontSize: 15 }}>
                          Delete
                        </span>
                      </Button>
                    )}
                    <ListItemText />
                    <Button
                      onClick={this.handleClose}
                      className="iconBtnCheck"
                      size="small"
                    >
                      {' '}
                      <span style={{ color: 'grey', fontSize: 15 }}>
                        Cancel
                      </span>
                    </Button>
                    {this.state.event.eventType &&
                      this.state.event.eventType.includes('happened') && (
                        <Button
                          onClick={() =>
                            this.handleSaveEvent(
                              this.state.event.tracker.type,
                              this.state.event.eventType
                            )
                          }
                          className="iconBtnCheck"
                          size="small"
                        >
                          {' '}
                          {this.state.event.tracker &&
                          this.state.event.tracker.type === 'checked' ? (
                            <CheckIcon
                              style={{
                                color: 'green',
                                fontSize: 20,
                                paddingLeft: 10
                              }}
                            />
                          ) : (
                            <span style={{ color: 'grey', fontSize: 15 }}>
                              Save
                            </span>
                          )}
                          {this.state.event.eventType.includes('happened') ? (
                            this.state.savingEvent ? (
                              <Loading />
                            ) : this.state.savingBookPref ? (
                              <Loading />
                            ) : this.state.savingTask ? (
                              <Loading />
                            ) : this.state.savingSubtask ? (
                              <Loading />
                            ) : (
                              <ChevronRightIcon
                                style={{
                                  color: 'lightgrey',
                                  fontSize: 20,
                                  paddingLeft: 10
                                }}
                              />
                            )
                          ) : (
                            ''
                          )}
                        </Button>
                      )}
                  </ListItem>
                </List>
              )}
            </div>
          </Paper>
        </Modal>
        <TimerModal
          open={this.state.OpenTimer}
          onClose={this.handleCloseTimer}
          event={this.state.event}
          update={e => this.eventFromTimer(e)}
        />
        <BooksModal
          open={this.state.OpenBooks}
          onClose={this.handleCloseBooks}
          update={(bookId, bookName, bookPrefId, maxPage, totalPages) =>
            this.updateCurrentBook(
              bookId,
              bookName,
              bookPrefId,
              maxPage,
              totalPages
            )
          }
        />
        <TaskEditModal
          open={this.state.OpenTask}
          onClose={this.handleCloseTask}
          task={this.state.task}
          action={'add'}
          type={this.state.taskType}
          update={(id, name) => this.updateTaskAfterAdd(id, name)}
        />
        <DeleteModal
          open={this.state.OpenDelete}
          onClose={this.handleCloseDelete}
          yes={() => this.handleDelete(this.state.event.id)}
          loading={this.state.loadingDel}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/EventEdit.js